<template>
  <div v-if="goodsList && goodsList.length">
    <div class="title">猜你喜欢</div>
    <div class="product-list-body">

      <index-product-body
              :item="item"
              :index="index"
              v-for="(item, index) in goodsList"
              v-bind:key="index"
      ></index-product-body>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import IndexProductBody from './home/index/IndexProductBody'
import { getGuessLike } from '../api/homeindex'
export default {
  name: 'GuessLike',
  data () {
    return {
      goodsList: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.member.info
    })
  },
  components: {
    IndexProductBody
  },
  props: {

  },
  created: function () {
    if (this.user) {
      getGuessLike(this.user.member_id).then(res => {
        this.goodsList = res.result.goods_list
      })
    }
  },
  methods: {

  }
}
</script>
<style>
  .product-list-body{display: flex; flex-wrap: wrap;background: #fff}
  .title{text-align: center;position:relative;font-size:.7rem;color:#999;margin-bottom:1rem;}
  /* .title::before{content:' '; background:#e0e0e0; height: 1px; position:absolute; left:0.5rem; right:60%; top:50%;} */
  /* .title::after{content:' '; background:#e0e0e0; height: 1px; position:absolute; left:60%; right:0.5rem; top:50%;} */
</style>
